module.exports = __webpack_public_path__ + "static/media/gift_certificate.df1f81c6.jpg";